module.exports = __webpack_public_path__ + "fonts/24a92ab.woff";